import { i18n } from '@lingui/core'
import * as Model from 'api/model'

const translateEnum = (enumName: Model.EnumName, value: string) => {
  const translationKey = `${enumName}_${value}`
  return i18n._(translationKey)
}

export default translateEnum
